import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import "./page.css"
import { useIssueOrderMutation } from "../store/api/orderAPI";

import { useActionsHook } from "../hooks/useActionsHook";
import { Toast } from 'primereact/toast';
import { orderColumnIssue } from "../metadata/order";
import { addOrder } from "../store/slices/order";
import { useDispatch, useSelector } from "react-redux";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { useGetOrderPvzQuery } from "../store/api/orderSortApi";
import { useOrderPaymentMutation } from "../store/api/orderSortApi";
import { t } from "i18next";
import { Sidebar } from "primereact/sidebar";
import Editor from "../components/UI/editor";
import MyButton from "../components/UI/Button";


function Issue() {
	const [formData, setFormData] = useState({});
	const [visibleDialog, setVisibleDialog] = useState(false);
	const [deliverDialog, setDeliverDialog] = useState(false);
	const [selectedDelivery, setSelectedDelivery] = useState(null);
	const orderColumnTr = useTranslatedColumns(orderColumnIssue);
	const { auth } = useSelector(state => state.auth);
	const role = auth?.role ?? 'Админ';
	const [orderPay] = useOrderPaymentMutation();
	const [globalFilterValue, setGlobalFilterValue] = useState('');
	const dispatch = useDispatch();
	const { order: orders } = useSelector(state => state.order)
	const toast = useRef(null);
	const [selectedProducts, setSelectedProducts] = useState(null);
	const { data: { result: order } = { result: [] }, isLoading: isLoadingOrder, refetch } = useGetOrderPvzQuery();
	const [issueOrder, { isLoading: isIssuing }] = useIssueOrderMutation();

	const openIssueDialog = (delivery) => {
		let rate = 0
		if (delivery.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
			rate = 999;
		} else if (delivery.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
			rate = 1100;
		}
		const weight = Math.ceil((delivery.gross_weight ?? 0) * 10) / 10;

		const updatedDelivery = {
			...delivery,
			delivery_cost:
				delivery?.shipping_cost && delivery.shipping_cost > 0
					? Number(delivery.shipping_cost)
					: weight * rate
		};

		setSelectedDelivery(updatedDelivery);
		setVisibleDialog(true);
	};

	const confirmIssue = async () => {
		await issueOrder(selectedDelivery)
		refetch()
		setVisibleDialog(false);
	};
	const [paymentModal, setPaymentModal] = useState({
		visible: false,
		data: null,
	});
	function togglePayment(bool, data) {
		if (!data) {
			setPaymentModal({
				visible: false,
				data: {},
			});
			return
		}
		let rate = 0
		if (data?.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
			rate = 999;
		} else if (data?.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
			rate = 1100;
		}
		const weight = Math.ceil((data.gross_weight ?? 0) * 10) / 10; // ⬅️ округляем вверх до 0.1 кг

		let summa = weight * rate;
		setPaymentModal({
			visible: bool,
			data: { ...data, summa: (data.shipping_cost && data.shipping_cost > 0) ? Number(data.shipping_cost) : summa },
		});
	}
	const actions = useActionsHook([
		{
			onClick: async (e, data) => {
				try {
					openIssueDialog(data)
				} catch (err) {
					toast.current.show({
						severity: "error",
						summary: "Ошибка",
						detail: err?.data?.message || "Ошибка при отправке QR-кода",
						life: 3000,
					});
				}
			},
			icon: "pi pi-plus",
			tooltip: "Оформить выдачу",
		}, {
			onClick: (param, row) => {
				if (role == "Админ" || role == "Менеджер") {
					togglePayment(true, row)
				}
			},
			icon: "pi pi-dollar",
		}
	]);

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	useEffect(() => {
		if (Array.isArray(order) && order.length) {
			if (orders.find(item => item?.tracking_number == order[0]?.tracking_number)) {
				return
			}
			dispatch(addOrder(order[0]))
		}
	}, [order])

	const onGlobalFilterChange = (e) => {
		const value = e.target.value;
		setGlobalFilterValue(value);
	};

	const renderHeader = () => {
		return (
			<div className="flex justify-content-end">
				<IconField iconPosition="left">
					<InputIcon className="pi pi-search" />
					<InputText value={globalFilterValue} style={{ padding: 8, paddingLeft: 38 }} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
				</IconField>
			</div>
		);
	};

	return (<>
		<Toast ref={toast} />
		<PresortDemo
			isLoading={isLoadingOrder}
			data={order}
			selection={selectedProducts}
			selectionMode="multiple"
			onSelectionChange={(e) => setSelectedProducts(e.value)}
			header={renderHeader()}
			column={orderColumnTr}
			toggleSidebar={toggleSidebar}
			deleteHandler={(row, field) => {
			}}
			globalFilterFields={orderColumnTr.map(item => item.attr)}
			globalFilter={globalFilterValue}
			actions={actions}
			scrollHeight="calc(100vh - 120px)"
		/>
		<Dialog
			header="Оформить выдачу"
			visible={visibleDialog}
			style={{ width: '30rem' }}
			onHide={() => setVisibleDialog(false)}
			footer={
				<div className="p-d-flex p-jc-end">
					<Button label="Cancel" className="p-button-text" onClick={() => setVisibleDialog(false)} />
					<Button label="Confirm" icon="pi pi-check" onClick={confirmIssue} autoFocus />
				</div>
			}>
			{selectedDelivery && (
				<>
					<p><strong>Получатель:</strong> {selectedDelivery?.client}</p>
					<p><strong>Страна:</strong> {selectedDelivery?.country}</p>
					<p><strong>Заказ трек номер:</strong> {selectedDelivery?.tracking_number}</p>
					<p><strong>Клиент код:</strong>{selectedDelivery?.client_code}</p>
					<div className="p-field">
						<label htmlFor="balance">Сумма к оплате</label>
						<InputNumber
							id="balance"
							value={selectedDelivery.delivery_cost}
							onValueChange={(e) => {
								setSelectedDelivery({
									...selectedDelivery,
									delivery_cost: e.value
								})
							}}
							showButtons
						/>
					</div>
				</>
			)}
		</Dialog>

		<Dialog
			header="Оформить отправку до дома"
			visible={deliverDialog}
			style={{ width: '30rem' }}
			onHide={() => setDeliverDialog(false)}
			footer={
				<div className="p-d-flex p-jc-end">
					<Button label="Отмена" className="p-button-text" onClick={() => setDeliverDialog(false)} />
					<Button label="Отправить" icon="pi pi-check" onClick={confirmIssue} autoFocus />
				</div>
			}
		>
			{selectedDelivery && (
				<>
					<p><strong>Получатель:</strong> {selectedDelivery?.client}</p>
					<p><strong>Адресс:</strong> {selectedDelivery?.country}</p>
					<p><strong>Заказ ID:</strong> {selectedDelivery?.tracking_number}</p>
					<p><strong>Стоимость:</strong> {selectedDelivery?.amount} {selectedDelivery?.currency}</p>
				</>
			)}
		</Dialog>
		{/* -------- Sidebar: PAYMENT -------- */}
		<Sidebar
			visible={paymentModal.visible}
			position="right"
			onHide={() => togglePayment(false)}
			style={{ width: "450px" }}
		>
			<h3 style={{ marginTop: 0 }}>{t("Оплата заказа")}</h3>

			<div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
				<div>
					<b>{t("Клиент")}:</b> {paymentModal?.data?.client_fio}
					<br />
					<b>{t("Трек-код")}:</b> {paymentModal?.data?.tracking_number}
				</div>

				{/* SUMMA */}
				<Editor
					attr="summa"
					data={paymentModal.data}
					placeholder={t("Сумма")}
					onBlur={(e, attr, value) =>
						setPaymentModal((s) => ({
							...s,
							data: { ...s.data, [attr]: value },
						}))
					}
				/>

				{/* TYPE PAYMENT */}
				<Editor
					attr="type_payment"
					data={paymentModal.data}
					placeholder={t("Тип оплаты (нал / карта)")}
					onBlur={(e, attr, value) =>
						setPaymentModal((s) => ({
							...s,
							data: { ...s.data, [attr]: value },
						}))
					}
				/>

				<MyButton
					label={t("save")}
					onClick={async () => {
						if (!paymentModal.data?.summa) {
							toast.current.show({
								severity: "error",
								summary: t("Введите сумму оплаты"),
								life: 3000,
							});
							return;
						}

						const { data, error } = await orderPay({
							order_guid: paymentModal.data.guid,
							summa: paymentModal.data.summa,
							type_payment: paymentModal.data.type_payment,
						});

						if (data?.success) {
							toast.current.show({
								severity: "success",
								summary: t("Оплата сохранена"),
								life: 3000,
							});
							togglePayment(false);
							refetch();
						} else {
							toast.current.show({
								severity: "error",
								summary: t("Ошибка при оплате"),
								detail: error?.data?.message,
								life: 3000,
							});
						}
					}}
				/>
			</div>
		</Sidebar>
	</>);
}

export default Issue;